const isTrue = process.env.REACT_APP_DEBUG === 'true';
export const isDebug = isTrue || false;
